import { FC, MouseEvent, ReactNode } from 'react';
import clsx from 'clsx';
import './button.scss';

interface IButtonProps {
    /** Тема кнопки. */
    theme: 'colorless' | 'green';

    /** Текст кнопки. */
    children: string;

    /** Показатель отключения кнопки. */
    disabled?: boolean;

    /** Тип кнопки. */
    type?: 'button' | 'submit' | 'reset';

    /** Дополнительные стили. */
    className?: string;

    /** Иконка перед текстом. */
    svg?: ReactNode;

    /** Действие при нажатии на кнопку. */
    onClick?(e: MouseEvent<HTMLButtonElement>): void;
}

export const Button: FC<IButtonProps> = (props) => {
    const { theme, children, svg, disabled, className, type, onClick } = props;

    return (
        <button
            className={clsx('button', `button--${theme}`, className)}
            type={type}
            disabled={disabled}
            onClick={onClick}>
            {svg}
            <div className='button__text'>{children}</div>
        </button>
    );
};
